import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const billedElsewhereReasonsAdapter = getAdapter({ idFieldName: 'value' });

const billedElsewhereReasonsSlice = createSlice({
  name: 'billedElsewhereReasons',
  initialState: billedElsewhereReasonsAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setBilledElsewhereReasons: (state, { payload: { billedElsewhereReasons } }) => {
      billedElsewhereReasonsAdapter.setAll(state, billedElsewhereReasons);
    }
  }
});

const selectors = billedElsewhereReasonsAdapter.getSelectors(({ billedElsewhereReasons }) => billedElsewhereReasons);

export const getBilledElsewhereReasons = state => selectors.selectAll(state);

export const { setBilledElsewhereReasons } = billedElsewhereReasonsSlice.actions;

export default billedElsewhereReasonsSlice.reducer;
